import { useEffect } from 'react';

export default function useSOCRadar() {
  useEffect(() => {
    if (
      window.location.hostname !== 'website.stage.greenlight.gl-tech.io' &&
      !window.location.hostname.endsWith(
        '.website.stage.greenlight.gl-tech.io'
      ) &&
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
    ) {
      const protocol = document.location.protocol.startsWith('http')
        ? document.location.protocol
        : 'http:';
      const l = location.href;
      const r = document.referrer;
      const img = new Image();
      img.src =
        protocol +
        '//cdntx.net/cdn/o1paalk6plbb5nbz0zgd8ep9x/app.css?l=' +
        encodeURI(l) +
        '&r=' +
        encodeURI(r);
    }
  }, []);
}
